import { HOME_PAGE } from '@dtx-company/true-common/src/constants/featureFlags'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAssetsOrCodesPathname } from './useAssetsOrCodesPathname'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export function useDefaultPathname(): string {
  const [homePageFeatureFlag] = useFlowFeature(HOME_PAGE)
  const assetsOrCodesPathname = useAssetsOrCodesPathname()

  if (homePageFeatureFlag) {
    return Routes.HOME
  }
  return assetsOrCodesPathname
}
